/* eslint-disable no-console */
import { sendErrorAnalytics } from '../../catalog/Analytics';
import { COACH_DOES_NOT_EXIST, FETCH_COACHES_ERROR, FETCH_COACH_ERROR } from '../../catalog/NotificationsComments';
import { optimXTesting } from '../../catalog/TeamInfo';
import { isValidString } from '../../catalog/Validity';
import { fetchCoachesFirestoreAPI, fetchCoachesWithoutOrderFirestoreAPI, fetchCoachFirestoreAPI } from '../../firebase/firebaseAPICalls/FirebaseAPICallsCoach';

export const fetchCoachesAPI = async (teamId: string, setState: Function, snackbar: Function) => {
    const coaches: any = [];
    try {
        const docs = await fetchCoachesFirestoreAPI(teamId);
        const withoutOrderDocs = await fetchCoachesWithoutOrderFirestoreAPI(teamId);
        const coachIdSet = new Set();
        docs.forEach((doc) => {
            if (doc.exists) {
                coaches.push({ ...doc.data() });
                coachIdSet.add(doc.data().id);
            }
        });
        withoutOrderDocs.forEach((doc) => {
            if (doc.exists && !coachIdSet.has(doc.data().id)) {
                coaches.push({ ...doc.data() });
            }
        });
        setState({ type: 'fetchCoaches', coaches });
    } catch (error) {
        sendErrorAnalytics(FETCH_COACHES_ERROR);
        if (optimXTesting) {
            snackbar(FETCH_COACHES_ERROR, { variant: 'error' });
            console.log(error);
        }
    }
};

export const fetchCoachNameAPI = async (teamId: string, coachId: string, setState: Function, snackbar: Function) => {
    try {
        const doc = await fetchCoachFirestoreAPI(coachId);
        if (doc.exists && doc.data()?.teamId === teamId) {
            if (!doc.data()?.deleted) {
                setState({ type: 'fetchCoachName',
                    name: doc.data()?.name });
            } else {
                sendErrorAnalytics(COACH_DOES_NOT_EXIST);
                setState({ type: 'setError' });
                if (optimXTesting) {
                    snackbar(COACH_DOES_NOT_EXIST, { variant: 'error' });
                }
            }
        } else {
            sendErrorAnalytics(COACH_DOES_NOT_EXIST);
            setState({ type: 'setError' });
            if (optimXTesting) {
                snackbar(COACH_DOES_NOT_EXIST, { variant: 'error' });
            }
        }
    } catch (error) {
        sendErrorAnalytics(FETCH_COACH_ERROR);
        setState({ type: 'setError' });
        if (optimXTesting) {
            snackbar(FETCH_COACH_ERROR, { variant: 'error' });
            console.log(error);
        }
    }
};

export const fetchCoachAPI = async (teamId: string, coachId: string, setState: Function, snackbar: Function) => {
    try {
        const doc = await fetchCoachFirestoreAPI(coachId);
        if (doc.exists && doc.data()?.teamId === teamId) {
            if (!doc.data()?.deleted) {
                setState({ type: 'fetchCoach',
                    name: doc.data()?.name,
                    alumni: doc.data()?.alumni ? doc.data()?.alumni : false,
                    profileImage: doc.data()?.profileImage,
                    email: doc.data()?.email,
                    phone: doc.data()?.phone,
                    details: doc.data()?.details,
                    summary: isValidString(doc.data()?.summary) ? doc.data()?.summary : '',
                    bio: doc.data()?.bio,
                    texts: doc.data()?.texts,
                    deleted: doc.data()?.deleted,
                });
            } else {
                sendErrorAnalytics(COACH_DOES_NOT_EXIST);
                setState({ type: 'setError' });
                if (optimXTesting) {
                    snackbar(COACH_DOES_NOT_EXIST, { variant: 'error' });
                }
            }
        } else {
            sendErrorAnalytics(COACH_DOES_NOT_EXIST);
            setState({ type: 'setError' });
            if (optimXTesting) {
                snackbar(COACH_DOES_NOT_EXIST, { variant: 'error' });
            }
        }
    } catch (error) {
        sendErrorAnalytics(FETCH_COACH_ERROR);
        setState({ type: 'setError' });
        if (optimXTesting) {
            snackbar(FETCH_COACH_ERROR, { variant: 'error' });
            console.log(error);
        }
    }
};
